import { Action } from 'redux';

import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IMetricInfo, isUsageMetricInfo } from '../models/IMetricInfo';

export const HideMetricsBanner = 'HideMetricsBanner';
export const ResumeMetric = 'ResumeMetric';
export const ResumeMetricFromExplorer = 'ResumeMetricFromExplorer';
export const UpdateMetricsData = 'UpdateMetricsData';
export const UpdateMetricsDataSucceeded = 'UpdateMetricsDataSucceeded';
export const AutoUpdateMetricDataStop = 'AutoUpdateMetricDataStop';
export const ReplaceMetricDataRefreshList = 'ReplaceMetricDataRefreshList';

export interface UpdateMetricsDataAction extends Action {
  type: typeof UpdateMetricsData;
  metrics: string[];
  force: boolean;
}

export function updateMetricsData(metrics: IMetricInfo[], force: boolean = false): UpdateMetricsDataAction {
  const ids = metrics
    .filter(m => !isUsageMetricInfo(m)) // usage metrics have a separate API where the data points are already provided
    .map(m => m.id);
  return updateMetricsDataByIds(ids, force);
}

export function updateMetricsDataByIds(ids: string[], force: boolean = false): UpdateMetricsDataAction {
  return {
    type: UpdateMetricsData,
    metrics: ids,
    force
  };
}

export interface UpdateMetricsDataSucceededAction extends Action {
  readonly metrics: ReadonlyArray<IMetricInfo>;
}

export function updateMetricsDataSucceeded(metrics: ReadonlyArray<IMetricInfo>): UpdateMetricsDataSucceededAction {
  return {
    type: UpdateMetricsDataSucceeded,
    metrics
  };
}

export interface ResumeMetricAction extends Action {
  metric: IMetricInfo;
  isOwner: boolean;
}

export function resumeMetric(metric: IMetricInfo, isOwner: boolean): ResumeMetricAction {
  return {
    type: ResumeMetric,
    metric,
    isOwner
  };
}

export interface ResumeMetricFromExplorerAction extends Action {
  metricId: string;
  isOwner: boolean;
}

export function resumeMetricFromExplorer(metricId: string, isOwner: boolean): ResumeMetricFromExplorerAction {
  return {
    type: ResumeMetricFromExplorer,
    metricId,
    isOwner
  };
}

export interface HideMetricsBannerAction {}

export function hideMetricsBanner(): HideMetricsBannerAction {
  return {
    type: HideMetricsBanner,
  };
}

export function autoUpdateMetricDataStop(): Action {
  return {
    type: AutoUpdateMetricDataStop
  };
}

export interface ReplaceMetricDataRefreshListAction extends Action {
  type: typeof ReplaceMetricDataRefreshList;
  ids: string[];
}

export function replaceMetricDataRefreshList(ids: string[]): ReplaceMetricDataRefreshListAction {
  return {
    type: ReplaceMetricDataRefreshList,
    ids
  };
}

export const isUpdateMetricsDataSucceededAction = isActionFactory<UpdateMetricsDataSucceededAction>(UpdateMetricsDataSucceeded);
